import { Component, Input, OnInit } from '@angular/core';
import { IPerson } from '../../../model/person';
import { LoginService } from '../../../services/login.service';
import { DireService } from '../../../services/dire.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';
import { PersonService } from '../../../services/person.service';
import { RechargeDireService } from "../../../services/recharge-dire.service";


@Component({
  selector: 'app-cli-company-info',
  templateUrl: './cli-company-info.component.html',
  styleUrls: ['./cli-company-info.component.css']
})
export class CliCompanyInfoComponent implements OnInit {

  @Input() person: IPerson;

  /**
   *
   * @param {LoginService} loginService
   * @param {DireService} direService
   * @param {TranslateService} translate
   * @param {ToastsManager} toastr
   * @param {PersonService} personService
   * @param {RechargeDireService} rechargeDireService
   */
  constructor(
    private loginService: LoginService,
    private direService: DireService,
    private translate: TranslateService,
    private toastr: ToastsManager,
    private personService: PersonService,
    private rechargeDireService: RechargeDireService
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit() {
    if (!this.person.identifier) {
      this.person = this.loginService.getPerson();
    }
  }

  /**
   *
   * @return {IPerson}
   */
  getPerson(): IPerson {
    return this.loginService.getPerson();
  }

  /**
   * Sincroniza el árbol de directorios y los datos de la empresa
   */
  rechargeCompanyInfo() {
    let personStorage = JSON.parse(localStorage.getItem('person'));
    this.synchronizeDire(personStorage.code).then(()=> {
      this.personService.getPersonAuthenticated()
        .subscribe(
          res => {
            localStorage.removeItem('person');
            localStorage.setItem('person', JSON.stringify(res));
            this.person = res;

            this.rechargeDireService.setRechargeFromClient(true);
          });
      },
    )
  }

  /**
   * Permite sincronizar el árbol de directorios
   *
   * @param root
   * @returns {Promise<any>}
   */
  synchronizeDire(root):Promise<any> {
    return new Promise<any>(resolve => {
      this.direService.synchronize(root)
        .subscribe(
          res => {
            this.translate.get('inv.companyInfo.synchronizeToast').subscribe((res: string) => {
              this.toastr.info(res).then();
            });
            resolve();
          });
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-company-info/cli-company-info.component.ts